export default {
  data() {
    return {
      email: "jm197900@163.com",
      mobile: "400-858-0193"
    };
  }
};